// https://stackoverflow.com/questions/951021/what-is-the-javascript-version-of-sleep
export function sleep(timeInMs: number) {
    return new Promise((resolve) => setTimeout(resolve, timeInMs));
}
